import React from 'react'
import ReactDOM from 'react-dom'
import { SnackbarProvider } from 'notistack'
import { ApolloProvider } from '@apollo/client'
import { createClient } from 'src/utils'
import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { SettingsProvider } from 'src/contexts/SettingsContext'
import { AuthProvider } from 'src/contexts/JWTAuthContext'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'react-perfect-scrollbar/dist/css/styles.css';

const client = createClient()
const renderApp = () => {
  ReactDOM.render(
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <SnackbarProvider maxSnack={3}>
        <SettingsProvider>
          <ApolloProvider client={client}>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ApolloProvider>
        </SettingsProvider>
      </SnackbarProvider>
    </MuiPickersUtilsProvider>,
    document.getElementById('root')
  )
}

renderApp()

serviceWorker.unregister()
